module.exports = __webpack_public_path__ + "img/jenkins.72505cf7.png";